// extracted by mini-css-extract-plugin
export default {"wrapper":"Direction_wrapper__+sq+f","iconOutcome":"Direction_iconOutcome__sUmLr","iconIncome":"Direction_iconIncome__uq58u","iconInside":"Direction_iconInside__b64Yp"};